import { Injector } from '@angular/core';

// DO NOT USE THIS FOR GENERAL DEPENDENCY INJECTION
// It was created for a very specific singular purpose:
// dependency injection on the content page without updating the constructor/super calls
export class StaticInjector {
  static injector: Injector;
}
